import { useQuery } from '@tanstack/react-query';
import { PluginAdapter } from './pluginAdapter';
import { PluginRepository } from './pluginInterface';
import { PluginQuery } from './pluginQuery';

export function createPluginRepository(adapter: PluginAdapter): PluginRepository {
    return {
        useFind(context, query, options) {
            return useQuery({
                ...options,
                queryKey: ['plugin-traits-v2', query],
                async queryFn() {
                    const response = await adapter.find(context, query);
                    return response;
                },
            });
        },
    };
}
